import { render, staticRenderFns } from "./S3Browser.vue?vue&type=template&id=62671d71&scoped=true"
import script from "./S3Browser.vue?vue&type=script&lang=js"
export * from "./S3Browser.vue?vue&type=script&lang=js"
import style0 from "./S3Browser.vue?vue&type=style&index=0&id=62671d71&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62671d71",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/home/bazzite/Work/awardapplication/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62671d71')) {
      api.createRecord('62671d71', component.options)
    } else {
      api.reload('62671d71', component.options)
    }
    module.hot.accept("./S3Browser.vue?vue&type=template&id=62671d71&scoped=true", function () {
      api.rerender('62671d71', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/core/components/S3Browser.vue"
export default component.exports